<template>
    <v-container fluid class="ma-3">
        <v-row class="text-center title">
            <v-col cols="9" class="text-left">
                <div style="display: inline-block">
                    <h1>Edit Program</h1>
                </div>
                <span v-if="user[0].can('see_restricted_programs')">
          <span class="ml-3 primary-color">
            <span v-if="!program.isRestricted" class="mdi mdi-earth" style="font-size: 24px"></span>
            <span v-else class="mdi mdi-security" style="font-size: 24px"></span>
          </span>
          <div style="display: inline-block; margin-left: 15px;">
            <v-switch
                    color="primary"
                    inset
                    v-model="program.isRestricted"
                    style="margin-top: 3px"
            ></v-switch>
          </div>
        </span>
            </v-col>
            <v-col cols="3" style="text-align: end" v-if="isProgramChanged">
                <v-btn color="primary" class="save-btn" @click="saveProgram" :disabled="isSaveButtonDisabled">
          <span class="mr-1" style="font-size: 18px">
            <i class="fas fa-save" data-fa-transform="shrink-2"></i>
          </span>
                    Save
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="1" class="p-0">
                <div class="condition__controls">
                    <label class="pt-2 font-weight-black">ID</label>
                    <input
                            type="text"
                            class="condition__matches campaign custom-input ml-2 w-75"
                            :value="program.id"
                            disabled
                    >
                </div>
            </v-col>
            <v-col cols="2" class="p-0">
                <div class="condition__controls">
                    <label class="pt-2 font-weight-black">Name</label>
                    <input type="text"
                           class="condition__matches campaign custom-input ml-2 w-75"
                           v-model="program.name"
                    >
                </div>
            </v-col>
            <v-col cols="2" class="p-0">
                <div class="condition__controls">
                    <label class="pt-2 font-weight-black">Advertiser</label>
                    <custom-select
                            :options="formattedAdvertisers"
                            v-model="program.advertiser"
                            label="name"
                            @input="switchAdvertiser"
                            class="condition__dimension-name custom_select advertiser-select"
                            :clearable="false"
                    ></custom-select>
                </div>
            </v-col>

            <v-col cols="2" class="p-0 ml-2">
                <div class="condition__controls">
                    <label class="pt-2 font-weight-black">Currency</label>
                    <select
                            :id="program.id"
                            v-model="program.currency"
                            class="condition__dimension-name condition__matches custom-select ml-2 w-75 test"
                            @change="setCurrency"
                    >
                        <option :value="null">-- Select currency --</option>
                        <option
                                v-for="{id, name} in currencies"
                                :selected="program.currency"
                                :key="id"
                                :disabled="false"
                        >{{name}}
                        </option>
                    </select>
                </div>
            </v-col>
            <v-col cols="2" class="p-0 ml-3">
                <div class="condition__controls">
                    <label class="pt-2 font-weight-black">Margin</label>
                    <select
                            :id="program.id"
                            class="condition__dimension-name condition__matches custom-select ml-2 w-75"
                            v-model="program.marginType"
                            @change="handleMarginType"
                    >
                        <option>-- Select margin --</option>
                        <option
                                v-for="{id, name} in marginTypes"
                                :selected="program.marginType"
                                :key="id"
                                :disabled="false"
                        >{{name}}
                        </option>
                    </select>
                </div>
            </v-col>
            <v-col cols="1" class="p-0">
                <div class="condition__controls">
                    <label v-if="program.marginType === 'percent' || program.marginType === 'correction'" class="pt-2 font-weight-black">%</label>
                    <input
                            v-if="program.marginType === 'percent' || program.marginType === 'correction'"
                            class="condition__matches campaign custom-input ml-3 w-75"
                            v-model="program.marginPercent"
                            type='number'
                            step='0.01'
                            @input="handlePercent"
                    >
                    <input
                            v-else
                            type="number"
                            class="condition__matches campaign custom-input ml-3 w-75"
                            v-model="program.price"
                            @input="handleProgramPrice"
                    >
                </div>
            </v-col>
        </v-row>
        <v-row>
            <div class="w-100">
                <b-tabs content-class="mt-3 tab-content">
                    <b-tab title="Rates" :active="selectedTab === 'rates'">
                        <v-row class="text-center" style="padding-left: 30px; padding-right: 30px">
                            <table class="w-100 fixed-table">
                                <thead style="height: 55px; border-bottom: 1px solid #7f98a5">
                                <tr>
                                    <th class="text-center geo-column">
                                        GEO
                                    </th>
                                    <th class="text-center payout-column">
                                        Payout
                                    </th>
                                    <th class="text-center price-column">
                                        Price
                                    </th>
                                    <th class="text-center percent">
                                        Percent
                                    </th>
                                    <th class="text-center action-column">
                                        Action
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <template v-for="(group, indexGroup) in groupedGeos">
                                <tr :key="indexGroup" class="mt-5" style="height: 60px">
                                    <td class="geo-column">
                                        <v-combobox
                                            v-model="group.selectedGeos"
                                            :items="availableCodesWithNames"
                                            chips
                                            multiple
                                            @change="(newValue) => handleGeoChange(indexGroup, newValue)"
                                        >
                                            <template #selection="{ item, index }">
                                                <v-chip
                                                    class="mr-2"
                                                    close
                                                    @click:close="removeItem(index, indexGroup)"
                                                >
                                                    {{ item }}
                                                </v-chip>
                                            </template>
                                        </v-combobox>
                                    </td>
                                    <td class="payout-column">
                                        <input
                                            type="number"
                                            v-model="group.payout"
                                            @input="updateGroupPayout(group)"
                                            class="custom-input"
                                            :readonly="program.marginType === 'percent' && group.margin_percent && !isNaN(Number(group.margin_percent)) || program.marginType === 'correction'"
                                            :class="{ 'readonly-bg': program.marginType === 'percent' && group.margin_percent && !isNaN(Number(group.margin_percent)) || program.marginType === 'correction' }"
                                        />
                                    </td>
                                    <td class="price-column">
                                        <input
                                                type="number"
                                                v-model="group.price"
                                                @input="updateGroupPrice(group)"
                                                class="custom-input"
                                                :readonly="program.marginType === 'percent' && !Number(group.margin_percent)"
                                                :class="{ 'readonly-bg': program.marginType === 'percent' && !Number(group.margin_percent) }"
                                        />
                                    </td>
                                    <td class="percent-column">
                                        <div style="display:flex; align-items: center;">
                                            <input
                                                v-model="group.margin_percent"
                                                @input="updateGroupPayoutByPercent(group)"
                                                type="number"
                                                class="custom-input"
                                                :readonly="program.marginType === 'correction'"
                                                :class="{ 'readonly-bg': program.marginType === 'correction' }"
                                            />
                                            <span class="ml-3" style="color: #7F98A5; font-size: 14px; font-weight: 900">
                                                %
                                            </span>
                                        </div>
                                    </td>

                                    <td class="action-column">
                                        <div v-if="program.marginType !== 'correction'" style="display: flex; gap: 8px; justify-content: center;">
                                            <button @click="addDeviceOverride(indexGroup)">📱</button>
                                            <button v-if="!group.selectedGeos.some((geo) => geo.includes('WW'))" @click="removeGroup(indexGroup)">🗑</button>
                                        </div>
                                    </td>

                                </tr>

                        
                                <!-- Device Override Sub-rows -->
                                <tr v-for="(override, overrideIndex) in (group.deviceOverrides || [])" :key="`override-${indexGroup}-${overrideIndex}`" 
                                    style="height: 60px; background-color: #f8f9fa;">
                                    <td class="geo-column" style="text-align: left; padding-left: 40px;">
                                        <select
                                            v-model="override.device_type"
                                            class="condition__dimension-name condition__matches custom-select w-50"
                                        >
                                            <option value="">-- Select device --</option>
                                            <option value="mobile">Mobile</option>
                                            <option value="desktop">Desktop</option>
                                            <option value="tablet">Tablet</option>
                                            <option value="tv">TV</option>
                                            <option value="console">Console</option>
                                        </select>
                                    </td>
                                    <td class="payout-column">
                                        <input
                                            type="number"
                                            v-model="override.payout"
                                            @input="updateOverridePayout(group, override)"
                                            class="custom-input"
                                            :readonly="program.marginType === 'percent' && override.margin_percent && !isNaN(Number(override.margin_percent)) || program.marginType === 'correction'"
                                            :class="{ 'readonly-bg': program.marginType === 'percent' && override.margin_percent && !isNaN(Number(override.margin_percent)) || program.marginType === 'correction' }"
                                        />
                                    </td>
                                    <td class="price-column">
                                        <input
                                            type="number"
                                            v-model="override.price"
                                            @input="updateOverridePrice(group, override)"
                                            class="custom-input"
                                            :readonly="program.marginType === 'percent' && !Number(override.margin_percent)"
                                            :class="{ 'readonly-bg': program.marginType === 'percent' && !Number(override.margin_percent) }"
                                        />
                                    </td>
                                    <td class="percent-column">
                                        <div style="display:flex; align-items: center;">
                                            <input
                                                v-model="override.margin_percent"
                                                @input="updateOverridePayoutByPercent(group, override)"
                                                type="number"
                                                class="custom-input"
                                                :readonly="program.marginType === 'correction'"
                                                :class="{ 'readonly-bg': program.marginType === 'correction' }"
                                            />
                                            <span class="ml-3" style="color: #7F98A5; font-size: 14px; font-weight: 900">
                                                %
                                            </span>
                                        </div>
                                    </td>
                                    <td class="action-column">
                                        <div style="display: flex; gap: 8px; justify-content: center;">
                                            <button @click="removeDeviceOverride(group, overrideIndex)">🗑</button>
                                        </div>
                                    </td>
                                </tr>
                                </template>
                                </tbody>
                            </table>
                        </v-row>
                        <v-row>
                            <v-col class="font-weight-bold ml-5 action" cols="1" @click="addGeo()">
                                <div class="primary-color">
                                    + Add Geo
                                </div>
                            </v-col>

                        </v-row>
                    </b-tab >
                    <b-tab title="History" :active="selectedTab === 'history'">
                        <v-row class="text-center ml-5">
                            <table style="min-width: 95%">
                                <thead>
                                <tr class="header_history">
                                    <th class="text-center" v-for="header in tableHistoryHeaders">
                                        {{header.name}}
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr style="border-bottom: 2px solid #cccccc !important"
                                    v-for="item in historyLogs"
                                    :key="item.id"
                                >
                                    <td style="padding: 1%">{{item.user}}</td>
                                    <td>{{item.date}}</td>
                                    <td>
                                        <p v-for="field in item.field" class="mb-0">
                                            {{field}}
                                        </p>
                                    </td>
                                    <td>{{item.action}}</td>
                                    <td>
                                        <p v-for="change in item.changes" class="mb-0">
                        <span style="color: #d5d5d5;font-weight: bold; font-size: 14px; text-decoration: line-through">
                          {{change.split('->')[0]}}
                        </span>
                                            <span v-if="change.split('->')[1]">
<!--                          <i class="fas fa-arrow-right"></i>-->
                          &#8594
                        </span>
                                            <span style="color: #a3b3bd; font-weight: bold; font-size: 14px">
                          {{change.split('->')[1] || ''}}
                        </span>

                                        </p>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </v-row>
                    </b-tab>
                </b-tabs>
            </div>
            <div class="loader-wrapper" v-if="loading">
                <v-progress-circular
                        :size="50"
                        color="primary"
                        indeterminate
                ></v-progress-circular>
            </div>
        </v-row>
    </v-container>
</template>

<script>
    import { getAllISOCodes } from 'iso-country-currency';
    import {mapGetters, mapMutations, mapState, mapActions} from 'vuex';
    import store from "@/store";

    import {getCurrencyList, getMarginTypes, compareArrays, formatData} from "@/helpers";
    export default {
        name: 'createProgram',
        components: {
        },
        computed: {
            ...mapState('user', ['user']),
            ...mapGetters('advertisers', ['getSflAdvertisers']),
            ...mapGetters('programs', ['getCurrentProgram', 'getCurrentProgramHistory']),
            formattedAdvertisers() {
                return this.getSflAdvertisers.map(advertiser => ({
                    id: advertiser.id,
                    name: advertiser.name
                }));
            },
            actualCodes() {
                return this.groupedGeos.flatMap((group) =>
                    group.selectedGeos.map((geo) => {
                        const match = geo.match(/\(([^)]+)\)$/);
                        const code = match ? match[1] : geo;
                        return {
                            code: code,
                            payout: group.payout,
                            price: group.price,
                            margin_percent: group.margin_percent,
                            fullCode: geo
                        };
                    })
                );
            },
        },
        async created() {
            // if (!this.user[0].can('manage_offers')){
            //   await this.$router.push('/403');
            // }
        },
        async mounted() {
            this.programId = this.$route.params.id;
            const activeTab = localStorage.getItem('activeTab');
            this.selectedTab = activeTab === 'history' ? 'history' : 'rates';
            localStorage.setItem('activeTab', 'rates');

            await this.$store.dispatch('programs/getProgramHistory', { id: this.programId || 0 });
            this.historyLogs = this.getCurrentProgramHistory;
            this.formatLogs();

            await this.$store.dispatch('advertisers/saveSflAdvertisersStore', {
                limit: 1500,
                page: 1,
                orderBy: 'name',
                orderDirectionAsc: true,
                filters: {status: '\'active\''}
            });

            this.availableCodes = getAllISOCodes().map(code => (code.iso).toUpperCase());
            this.availableCodesWithNames =  getAllISOCodes().map(c => `${c.countryName} (${c.iso})`);
            this.availableCodesWithNames.unshift('Worldwide (WW)');
            this.availableCodesWithNamesInit =  [...this.availableCodesWithNames];

            if (this.programId) {
                try {
                    const program = localStorage.getItem('program');
                    if (!program) {
                        this.$router.push(`/advertisers/programs`);
                    }
                    this.program = JSON.parse(program);
                    this.originProgram = {...JSON.parse(program)};
                } catch (e) {
                    this.$router.push(`/advertisers/programs`);
                }
            }
            this.initWW();
            if (this.$route.name === 'CreateProgramBy') {
                this.isBasedByExisting = true;
                this.program.id = null;
            }

            // TODO: Temporarily removed this code due to an issue on prod2. We'll figure it out later.
            // TODO: The Advertiser Platform Aggregator is not present on prod2.
            // if (this.$route.name === 'CreateProgram' || this.$route.name === 'CreateProgramBy') {
            //   const hostName = window.location.hostname;
            //   if (hostName.includes('aezai') || hostName.includes('localhost')) {
            //     this.program.advertiser = 'Ad Firm';
            //   } else {
            //     this.program.advertiser = 'Platform Aggregator';
            //   }
            //   this.setAdvertiser();
            // }

            this.currencies = getCurrencyList();
            if (this.program.currency) {
                const cur = this.currencies.find(c => c.name.includes(this.program.currency));
                this.originProgram.currencyId = cur.id;
                this.program.currency = `${cur.symbol} (${this.program.currency})`;
            }
            this.originProgram.isRestricted = this.originProgram.isRestricted === 1;
            this.marginTypes = getMarginTypes();
            this.setCurrency();
            if (this.program.marginType === 'percent') {
                this.recalculatePrices();
            }
            document.title = `Program-${this.programId || 'create'}`;
            this.groupGeos();
        },
        watch: {
            program: {
                handler(val) {
                    if (!this.isJustLaunched) {
                        const isGeoChanged = !compareArrays(this.originProgram.geos, this.program.geos);
                        const isNameChanged = this.originProgram.name !== this.program.name;
                        const isAdvChanged = this.originProgram.advertiser !== this.program.advertiser;
                        const isCurChanged = this.originProgram.currencyId !== this.program.currencyId;
                        const isModeChanged = this.originProgram.isRestricted !== this.program.isRestricted;
                        const isMarginChanged = this.originProgram.marginType !== this.program.marginType;
                        const isPayoutChanged = this.originProgram.payout !== this.program.payout;

                        if (
                            isGeoChanged
                            || isNameChanged
                            || isAdvChanged
                            || isCurChanged
                            || isModeChanged
                            || isMarginChanged
                            || isPayoutChanged
                        ) {
                            this.isProgramChanged = true;
                        } else {
                            this.isProgramChanged = false;
                        }
                    }
                    this.isJustLaunched = false;

                },
                deep: true
            },
            actualCodes: {
                handler(codes) {
                    const appliedCountries = codes.map(c => c.fullCode);
                    this.availableCodesWithNames = [...this.availableCodesWithNamesInit.filter(c => !appliedCountries.includes(c))];
                    this.program.geos = [...this.actualCodes.map(i => {
                        i.code = i.fullCode;
                        delete  i.fullCode;
                        return i;
                    })];
                }
            }
        },
        methods: {
            ...mapActions('alert', ['ALERT_SUCCESS', 'ALERT_ERROR', 'ALERT_INFO', 'ALERT_WARNING', 'ALERT']),
            groupGeos() {
                const groups = {};
                let worldwideGroup = null;

                // First pass: group only base records (device_type === null)
                this.program.geos.forEach((geo) => {
                    if (geo.device_type) {
                        return; // Skip device overrides on first pass
                    }

                    if (geo.code.includes('WW')) {
                        if (!worldwideGroup) {
                            worldwideGroup = {
                                payout: geo.payout,
                                price: geo.price,
                                margin_percent: geo.margin_percent || this.program.marginPercent || null,
                                geos: [],
                                selectedGeos: [],
                                deviceOverrides: [],
                            };
                        }
                        worldwideGroup.geos.push(geo);
                        worldwideGroup.selectedGeos = worldwideGroup.geos.map((c) => c.code);
                    } else {
                        const groupKey = `${geo.payout}-${geo.price}`;
                        if (!groups[groupKey]) {
                            groups[groupKey] = {
                                payout: geo.payout,
                                price: geo.price,
                                margin_percent: geo.margin_percent,
                                geos: [],
                                selectedGeos: [],
                                deviceOverrides: [],
                            };
                        }
                        groups[groupKey].geos.push(geo);
                        groups[groupKey].selectedGeos = groups[groupKey].geos.map((c) => c.code);
                    }
                });

                // Second pass: add device overrides to corresponding groups
                this.program.geos.forEach((geo) => {
                    if (!geo.device_type) {
                        return; // Skip base records
                    }

                    // Check if it's a WW device override
                    if (geo.code.toUpperCase().includes('WW') && worldwideGroup) {
                        worldwideGroup.deviceOverrides.push({
                            device_type: geo.device_type,
                            payout: geo.payout,
                            price: geo.price,
                            margin_percent: geo.margin_percent,
                        });
                        return;
                    }

                    // Find group that contains this geo (by country code)
                    const geoName = geo.code;
                    for (let groupKey in groups) {
                        const group = groups[groupKey];
                        if (group.selectedGeos.includes(geoName)) {
                            group.deviceOverrides.push({
                                device_type: geo.device_type,
                                payout: geo.payout,
                                price: geo.price,
                                margin_percent: geo.margin_percent,
                            });
                            break;
                        }
                    }
                });

                this.groupedGeos = worldwideGroup
                    ? [worldwideGroup, ...Object.values(groups)]
                    : Object.values(groups);

                this.groupedGeosInit = [...this.groupedGeos];
            },
            handleGeoChange(indexGroup, newValue) {},
            recalculatePrices() {
                this.groupedGeos.forEach((group) => {
                    if (this.program.marginType === 'percent' && group.margin_percent) {
                        return;
                    }
                    group.price = (
                        Number(group.payout)/Number(1 - this.program.marginPercent / 100)
                    ).toFixed(2);
                });
            },
            handlePercent(){
                const value = Number(this.program.marginPercent);
                this.program.marginPercent = value.toFixed(2);

                this.recalculatePrices();
            },
            handleMarginType() {
                const worldWideGeo = this.program.geos.find(geo => geo.code.toUpperCase().includes('WW'));

                if (this.program.marginType === 'correction') {
                    this.program.payout = 0;
                    this.program.geos = [{ code: 'WW', payout: 0, price: this.program.price, margin_percent: this.program.marginPercent }];
                }

                if (this.program.marginType === 'fixed' || this.program.marginType === 'dynamic') {
                    worldWideGeo.price = this.program.price;
                } else {
                    this.recalculatePrices();
                }
            },
            handleProgramPrice() {
                const worldWideGeo = this.program.geos.find(geo => geo.code.toUpperCase().includes('WW'));
                worldWideGeo.price = this.program.price;
            },

            initWW() {
                this.program.marginPercent = Number(this.program.marginPercent).toFixed(2);

                if (Number(this.program.payout) > 0) {
                    const ww = {
                        code: 'WW',
                        payout: this.program.payout,
                        price: this.program.marginType === 'fixed' || this.program.marginType==='dynamic'
                            ? this.program.price
                            : (Number(this.program.payout)/Number(1-this.program.marginPercent/100)).toFixed(2),
                        margin_percent: this.program.marginPercent || null
                    };

                    this.program.geos.unshift(ww);
                    this.originProgram.geos.unshift(ww);
                }
                this.program.geos = this.program.geos.map(geo => {
                    geo.code = this.getCountryName(geo.code);
                    return geo;
                });
            },
            verifyGeo(code, index) {
                if (!this.availableCodes.includes(code.toUpperCase())) {
                    this.program.geos[index].code = '';
                    this.$refs[index][0].style.display = 'block';
                    setTimeout(() => {
                        this.$refs[index][0].style.display = 'none';
                    }, 3000);
                }
                if (code.toUpperCase() === 'WW') {
                    this.program.geos[index].code = '';
                }
                let curIndex = 0;
                let codeExists = 0;
                this.program.geos.forEach((geo, i) => {
                    if (geo.code.toUpperCase() === code.toUpperCase()) {
                        codeExists++;
                        curIndex = i;
                    }
                });
                if (codeExists > 1) {
                    this.program.geos.splice(curIndex, 1);
                }
                this.program.geos[index].code = this.getCountryName(this.program.geos[index].code)
            },
            getCountryName(code) {
                if (!code) return '';
                const codeValue = code.toUpperCase();
                const regionNamesInEnglish = new Intl.DisplayNames(['en'], { type: 'region' });
                let country = codeValue === 'WW' ? 'Worldwide' : regionNamesInEnglish.of(codeValue);
                country = country.replace('(', '');
                country = country.replace(')', '');
                return `${country} (${codeValue})`;
            },
            parseGeo(countryName) {
                const parts = countryName.split('(');
                let code;
                if (!parts.length) {
                    return null;
                }
                try {
                    code = parts[1].replace(')', '');
                } catch (e) {
                    return null
                }


                return code;
            },

            updateGroupPayout(group) {
                group.geos.forEach((geo) => {
                    geo.payout = group.payout;
                });
                if (this.program.marginType === 'percent') {
                    this.recalculatePrices()
                }
            },
            updateGroupPrice(group) {

                if (!group.geos || !Array.isArray(group.geos)) {
                    group.geos = [];
                }

                if (group.geos.length === 0) {
                    group.geos.push({
                        code: '',
                        payout: 0,
                        price: group.price,
                        margin_percent: group.margin_percent
                    });
                }

                group.geos.forEach((geo) => {
                    geo.price = group.price;
                    if (this.program.marginType === 'percent' && group.margin_percent) {
                        geo.payout = (geo.price * (1 - Number(group.margin_percent) / 100)).toFixed(2);
                        group.payout = (group.price * (1 - Number(group.margin_percent) / 100)).toFixed(2);
                    }
                });
            },
            updateGroupPayoutByPercent(group) {
                group.geos.forEach((geo) => {
                    geo.payout = (geo.price * (1 - Number(group.margin_percent) / 100)).toFixed(2);
                    geo.margin_price = group.margin_percent;
                });
                group.payout = (group.price * (1 - Number(group.margin_percent) / 100)).toFixed(2);
            },
            removeGroup(index) {
                this.groupedGeos = this.groupedGeos.filter((_, i) => i !== index);
            },

            addGeo() {
                const hasEmptyGroup = this.groupedGeos.some(
                    (group) =>
                        group.payout === 0 &&
                        group.price === 0 &&
                        group.geos.length === 0 &&
                        group.selectedGeos.length === 0
                );
                if (hasEmptyGroup) {
                    return;
                }
                this.groupedGeos.push({
                    payout: 0,
                    price: 0,
                    geos: [],
                    margin_percent: null,
                    selectedGeos: []
                });
            },
            removeGeo(code) {
                this.program.geos = [...this.program.geos.filter(geo => geo.code !== code)];
            },

            removeItem(index, indexGroup) {
                const group = this.groupedGeos[indexGroup];
                if (group) {
                    group.selectedGeos.splice(index, 1);
                }
            },
            addDeviceOverride(indexGroup) {
                const group = this.groupedGeos[indexGroup];
                if (!group.deviceOverrides) {
                    this.$set(group, 'deviceOverrides', []);
                }
                group.deviceOverrides.push({
                    device_type: '',
                    payout: 0,
                    price: 0,
                    margin_percent: group.margin_percent || null
                });
            },
            removeDeviceOverride(group, overrideIndex) {
                group.deviceOverrides.splice(overrideIndex, 1);
            },
            updateOverridePayout(group, override) {
                if (this.program.marginType === 'percent') {
                    this.recalculateOverridePrice(override);
                }
            },
            updateOverridePrice(group, override) {
                if (this.program.marginType === 'percent' && override.margin_percent) {
                    override.payout = (override.price * (1 - Number(override.margin_percent) / 100)).toFixed(2);
                }
            },
            updateOverridePayoutByPercent(group, override) {
                override.payout = (override.price * (1 - Number(override.margin_percent) / 100)).toFixed(2);
            },
            recalculateOverridePrice(override) {
                if (override.margin_percent && !isNaN(Number(override.margin_percent))) {
                    return;
                }
                override.price = (
                    Number(override.payout)/Number(1 - this.program.marginPercent / 100)
                ).toFixed(2);
            },
            async saveProgram() {
                if (!this.program.advertiserId) {
                    this.ALERT_ERROR('Please, select advertiser');
                    return;
                }
                if (!this.program.currencyId) {
                    this.ALERT_ERROR('Please, select currencyId');
                    return;
                }
                const emptyGeos = this.program.geos.filter(geo => !geo.code);
                if (emptyGeos.length) {
                    return;
                }

                // Преобразуем groupedGeos в плоский массив с device_type
                const flatGeos = [];
                this.groupedGeos.forEach(group => {
                    // Основные записи (device_type = null)
                    group.selectedGeos.forEach(geoFullName => {
                        const geoCode = this.parseGeo(geoFullName);
                        if (geoCode && geoCode.toUpperCase() !== 'WW') {
                            flatGeos.push({
                                code: geoCode,
                                payout: group.payout,
                                price: group.price,
                                margin_percent: group.margin_percent,
                                device_type: null
                            });
                        }
                    });
                    
                    // Device overrides
                    if (group.deviceOverrides && group.deviceOverrides.length) {
                        group.deviceOverrides.forEach(override => {
                            if (override.device_type) {
                                group.selectedGeos.forEach(geoFullName => {
                                    const geoCode = this.parseGeo(geoFullName);
                                    if (geoCode) {
                                        flatGeos.push({
                                            code: geoCode,
                                            payout: override.payout,
                                            price: override.price,
                                            margin_percent: override.margin_percent,
                                            device_type: override.device_type
                                        });
                                    }
                                });
                            }
                        });
                    }
                });

                this.program.geos = flatGeos;
                
                let worldWideGeo = this.program.geos.find(geo => geo.code.toUpperCase().includes('WW'));

                if (worldWideGeo && !worldWideGeo.payout && this.program.marginType !== 'correction') {
                    this.ALERT_ERROR('Please, set Worldwide payout');
                    return;
                }

                if (!worldWideGeo) {
                    const wwGroup = this.groupedGeos.find(g => g.selectedGeos.some(geo => geo.includes('WW')));
                    worldWideGeo = wwGroup ? { 
                        code: 'WW', 
                        payout: wwGroup.payout, 
                        price: wwGroup.price 
                    } : { code: 'WW', payout: 0, price: 0 };
                }

                if (!this.program.currencyId || !this.program.name || !['fixed', 'percent', 'dynamic','correction'].includes(this.program.marginType)) {
                    return;
                }
                const currency = this.currencies.find(cur => cur.id === this.program.currencyId);
                this.isSaveButtonDisabled = true;

                if (this.program.id) {
                    this.isBasedByExisting = false;
                }

                try {
                    if (this.program.marginType === 'correction') {
                        this.program.payout = 0;
                        this.program.geos.forEach(geo => geo.payout = 0);
                    }

                    console.log(this.program);
                    await store.dispatch('programs/createProgram', {
                        id: this.program.id,
                        name: this.program.name,
                        price: this.program.marginType === 'fixed' || this.program.marginType === 'dynamic'
                            ? this.program.price
                            : worldWideGeo.price,
                        payout: worldWideGeo.payout,
                        advertiserId: this.program.advertiserId,
                        advertiser: this.program.advertiser,
                        currencyId: this.program.currencyId,
                        currency: currency.abbr,
                        marginType: this.program.marginType,
                        marginPercent: this.program.marginPercent,
                        lastUpdatedBy: this.user[0].email,
                        isRestricted: this.program.isRestricted ? 1 : 0,
                        geos: this.program.geos,
                        isBasedByExisting: this.isBasedByExisting ? 1 : 0
                    });

                    if (this.getCurrentProgram) {
                        this.program.id = this.getCurrentProgram.id
                    }

                    localStorage.setItem('program', JSON.stringify(this.program));
                    await this.$store.dispatch('programs/getProgramHistory', { id: this.program.id || 0 });
                    this.historyLogs = this.getCurrentProgramHistory;

                    this.formatLogs();

                    const action = this.program.id ? 'updated' : 'created';
                    this.ALERT_SUCCESS(`Program has been ${action}`, {});

                    this.isSaveButtonDisabled = false;

                    this.program.geos.forEach(geo => {
                        geo.code = this.getCountryName(geo.code);
                    });

                } catch (e) {
                    console.log(e.message);
                    store.dispatch('alert/ALERT_ERROR', `An error has occurred.`, {root: true});
                } finally {
                    this.isSaveButtonDisabled = false;
                    setTimeout(() => {
                        store.dispatch('alert/ALERT_REMOVE', ``, {root: true});
                    }, 3000);
                }

            },
            setAdvertiser() {
                const advertiser = this.getSflAdvertisers.find(adv => adv.name === this.program.advertiser);
                if (advertiser) {
                    this.program.advertiserId = advertiser.id;
                }
            },
            switchAdvertiser() {
                this.program.advertiserId = this.program.advertiser.id;
            },
            setCurrency() {
                const currency = this.currencies.find(cur => cur.name === this.program.currency);
                if (currency) {
                    this.program.currencyId = currency.id;
                }
            },
            formatLogs() {
                this.historyLogs.forEach(hl => {
                    hl.date = formatData(new Date(+hl.date));
                    const isGeoRateChanged = hl.field.find(h => ['rate:price', 'rate:payout'].includes(h));
                    if (isGeoRateChanged) {
                        hl.field.unshift('rate:geo');
                    }
                });
            }
        },
        data() {
            return {
                groupedGeos: [],
                groupedGeosInit: [],
                selectedTab: 'rates',
                isProgramChanged: false,
                isBasedByExisting: false,
                availableCodes: [],
                availableCodesWithNames: [],
                availableCodesWithNamesInit: [],
                isSaveButtonDisabled: false,
                originProgram: {
                    geos: []
                },
                isJustLaunched: true,
                id: null,
                program: {
                    id: null,
                    name: '',
                    advertiser_id: null,
                    currency_id: null,
                    marginType: 'percent',
                    marginPercent: 15,
                    isRestricted: 0,
                    price: 0,
                    payout: 0,
                    geos: []
                },
                currencies: [],
                marginTypes: [],
                tab: null,
                loading: false,
                programId: null,
                items: [
                    'General', 'Payin/Payout', 'Restrictions', 'History',
                ],
                tableHistoryHeaders: [
                    { name: 'User (E-mail)' },
                    { name: 'Date/Time' },
                    { name: 'Field' },
                    { name: 'Action' },
                    { name: 'Changes' },
                ],
                historyLogs: []
            };
        }
    };

</script>
<style lang="sass">
    .header_history
        height: 50px !important
        border-bottom: 2px solid #cccccc
        .nav-tabs .nav-link.active
            font-size: 14px !important
            font-weight: bold
            color: var(--v-primary-base) !important
        .nav-tabs .nav-link
            font-size: 14px !important
            font-weight: bold
            color: #7F98A5 !important

        .tab-content
            background: white
            min-height: 500px
        .dollar::before
            content: '\f155'
            font-family: "Font Awesome 5 Free"
            font-weight: 900
            font-size: 18px
            color: #ACC3CF
            opacity: 0.7
            float: left
            position: relative
            top: 8px !important
            left: 43px !important
            z-index: 1
        .input-table
            text-align: left !important
            width: 90% !important
            padding-left: 40px !important
        .actions
            width: 100%
            text-align: center
        .trash
            font-size: 24px
            color: #7F98A5
        .save-btn
            color: white !important
        .action :hover
            cursor: pointer
        .advertiser-select
            height: 45px
            .vs__dropdown-toggle
                height: 45px
                border: 2px solid #e3eef4
                border-radius: 0.25rem
            .vs__selected
                font-family: "proxima-nova", Proxima Nova, Helvetica, Arial, sans-serif !important
                font-size: 14px
                font-weight: 500
                color: #7F98A5
                background: #fff
                text-align: left
                width: 75% !important
                transition: all 0.5s ease

        input[aria-labelledby*="combobox"]
            height: 35px
            border: none
            background-color: transparent

    label.pt-2.font-weight-black
        padding-right: 2px

    .fixed-table
        table-layout: fixed !important
        width: 100%

    .fixed-table th, .fixed-table td
        overflow: hidden
        text-overflow: ellipsis
        white-space: nowrap


    .geo-column
        width: 40% !important
        padding-right: 1% !important

    .payout-column
        width: 20% !important
        padding-right: 1% !important

    .price-column
        width: 20% !important
        padding-right: 1% !important

    .percent-column
        width: 5% !important


    .action-column
        width: 10% !important

    .readonly-bg
        background-color: #d3d3d3 !important
        cursor: not-allowed !important

</style>